const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Hello and Goodbye",
  description: "Learn to say hello and goodbye",
  picture: "",
  difficulty: "ALL",
  learnLang: "english",
  actor1: {
    name: "Cathy",
    voice: "Kimberly",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMy5wbmcifQ==",
  },
  actor2: {
    name: "Jimmy",
    voice: "Joey",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNC5wbmcifQ==",
  },
  script: [
    { text: "Hello. How are you doing?", actor: 1 },
    { text: "I'm well. Thanks for asking. How are you?", actor: 2 },
    { text: "I can't complain, Life is treating me well.", actor: 1 },
    { text: "That's good to hear.", actor: 2 },
    {
      text: "Good to see you again, I need to go to my doctor's appointment.",
      actor: 1,
    },
    { text: "Nice seeing you.", actor: 2 },
    { text: "See you later.", actor: 1 },
  ],
};

export default helloAndGoodbye;
